<template>
    <div class="teacher-list-shell">
        <div class="teacher-header">
            <div class="teacher-header-left">
                <img class="img" src="@/assets/teacher.png" alt=""/>
                <span class="span">名师风采</span>
            </div>
            <div class="teacher-header-right">
                <span class="span3 pointer" @click="$router.push('/teacher')">查看更多</span>
                <img class="img2" src="@/assets/right.png" alt=""/>
            </div>
        </div>
        <div class="teacher-list" ref="homeNews">
            <div class="teacher-box-shell" v-for="(item,index) in teacher_list" :key="index" @click="$router.push('/teacher-detail?lector_id='+item.lector_id)">
                <div class="teacher-box handler">
                    <div class="teacher-box-header">
                        <div class="teacher-img">
                            <img :src="item.lector_img" alt=""/>
                        </div>
                        <div class="teacher-name">{{item.lector_name}}</div>
                    </div>
                    <div class="teacher-desc" >{{item.lector_desc.substring(0,100)}}...</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    data () {
      return {
        teacher_list: [],
        homeNews: null
      }
    },
    mounted () {
      window.clearInterval(this.homeNews)
      window.scrollTo(0, 0)
      this.get_list()
    },
    methods: {
      get_list () {
        this.API.post('Home/lector_out-get_teacher_list', {
          page: this.page,
          page_size: 20
        }).then((res) => {
          this.teacher_list = res.data.teacher_list
          setTimeout(()=>{
            this.newsScroll()
          },10)
        })
      },
      newsScroll () { // 消息滚动
        let _this = this
        _this.$nextTick(() => {
          let startX = 0
          for (let item of _this.$refs.homeNews.children) {
            startX += item.offsetWidth
          }
          _this.endOffsetX = startX / 2
          let offsetX = _this.$refs.homeNews.scrollLeft
          _this.homeNews = setInterval(() => {
            if (offsetX > _this.endOffsetX) {
              offsetX = 0
            } else {
              offsetX += 1
            }
            _this.$refs.homeNews.scrollLeft = offsetX
          }, 30)
        })
      },
    },
    destroyed () {
      window.clearInterval(this.homeNews)
    },
  }
</script>

<style lang="less" scoped>
    .teacher-list-shell {
        padding-bottom: 20px;

        .teacher-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 100px;
            margin-bottom: 10px;

            .teacher-header-left, .teacher-header-right {
                display: flex;
                align-items: center;
                height: 100%;
            }

            .teacher-header-left {
                .img {
                    width: 52px;
                    height: 52px;
                }

                .span {
                    font-size: 36px;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    color: #333333;
                    margin-left: 25px;
                }
            }

            .teacher-header-right {
                .span3 {
                    font-size: 24px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #999999;
                    margin-right: 16px;
                }

                .img2 {
                    width: 13px;
                    height: 21px;
                }
            }
        }
    }

    .teacher-list {
        height: 560px;
        padding: 0 20px;
        display: flex;
        align-items: center;
        color: #000;
        /*white-space: nowrap;*/
        overflow-x: scroll;
        width: auto;

        .teacher-box-shell {
            display: inline-block;
            width: 33.3%;
            min-width: 33.3%;
            padding-right: 20px;

            .teacher-box {
                width: 100%;
                height: 520px;
                padding-bottom: 52px;
                overflow: hidden;
                background: #FFFFFF;
                box-shadow: 0px 1px 27px 3px rgba(204, 204, 204, 0.3);
                border-radius: 10px;

                .teacher-box-header {
                    text-align: center;

                    .teacher-img {
                        width: 130px;
                        height: 130px;
                        margin: 46px auto 0;
                        border-radius: 50%;

                        img {
                            width: 100%;
                            height: 100%;
                            border-radius: 50%;
                        }
                    }

                    .teacher-name {
                        margin: 33px auto;
                        font-size: 30px;
                        font-family: Microsoft YaHei;
                        font-weight: bold;
                        color: #000000;
                    }
                }

                .teacher-desc {
                    width: 90%;
                    margin: 0 auto;
                    font-size: 18px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #333333;
                    overflow: hidden;
                    line-height: 36px;
                    min-height: 90px;
                }
            }
        }
    }

    /*.teacher-list::-webkit-scrollbar-thumb {*/
    /*    !*background: #2aa9b5;*!*/
    /*    background: #ccc;*/
    /*    border-radius: 10px;*/
    /*}*/
</style>
